module.exports = __webpack_public_path__ + "static/media/push-route.37d1b7f1.gif";